<template>
  <div>
    <v-menu
      v-model="isMenuOpen"
      :close-on-content-click="false"
      :disabled="disabled"
      location="top"
      transition="fade-transition"
      activator="parent"
    >
      <template #activator="{ props }">
        <slot name="trigger" v-bind="props" />
      </template>

      <v-card class="menu-card">
        <v-card-text class="text--small text--regular">
          <slot />
        </v-card-text>
        <v-card-actions v-if="$slots.actions" class="menu-actions">
          <slot name="actions" />
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'Popover',
  data () {
    return {
      isMenuOpen: false,
    }
  },
  props: {
    disabled: {
      type: Boolean,
    },
  },
  methods: {
    open () {
      this.isMenuOpen = true
    },
    close () {
      this.isMenuOpen = false
    },
  },
}
</script>

<style scoped lang="scss">
.menu-card {
  background: white;
  border: 1px solid rgb(var(--v-theme-grey-200));
  border-radius: 10px !important;
  padding: 4px;
  min-width: 250px;
}

.menu-actions {
  display: flex;
  justify-content: flex-end;
  column-gap: 12px;
}
</style>
